import { useUser } from "@/composables/user/user";
import { Layout } from "@/router/types";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login/helpers";
import { useRoute } from "vue-router";

export function useAppLayout() {
  const layout = ref<Layout>();

  const route = useRoute();
  const { user } = useUser();

  const recomputeLayout = async () => {
    // Prevent flickering when user is not logged in yet
    await checkUserOnInitialPageLoad();

    // Initial page load
    if (route.name === undefined) {
      return undefined;
    }

    layout.value = route.meta.layout ?? Layout.Default;
  };

  watch(route, recomputeLayout);
  watch(user, recomputeLayout);

  return {
    layout,
  };
}
